(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDeleteController',CustomServiceTypeAttributeDeleteController);

    CustomServiceTypeAttributeDeleteController.$inject = ['$uibModalInstance', 'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDeleteController($uibModalInstance, entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CustomServiceTypeAttribute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
